import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Radio } from 'react-bootstrap'

export const RadioField = ({ input, id, label }) => {
	return <FormGroup
		id={id}
		bsClass={'form-group mb-0'}
	>
		<Radio {...input}>
			{label}
		</Radio>
	</FormGroup>
}

RadioField.propTypes = {
	input: PropTypes.object,
	id: PropTypes.string,
	label: PropTypes.string
}

export default RadioField



// WEBPACK FOOTER //
// ./src/components/RadioField.js